import { render } from "./BlckNotifications.vue?vue&type=template&id=a28b455a&scoped=true"
import script from "./BlckNotifications.vue?vue&type=script&lang=js"
export * from "./BlckNotifications.vue?vue&type=script&lang=js"

import "./BlckNotifications.vue?vue&type=style&index=0&id=a28b455a&scoped=true&lang=scss"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a28b455a"]])

export default __exports__